/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

// `globalThis` is missing in some of our browser targets (Chrome 49, Safari 10), so we fall back
// to `global` and `window`. Once the browser targets support `globalThis`, use it directly.
var globalObject =
// $FlowFixMe[cannot-resolve-name] Flow 0.148 doesn't know about `globalThis`
typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : {};

// React Native Web exposes both CJS and ESM versions.
// This avoids duplicating the registry itself, returning the same data through either CJS or ESM.
var ASSET_REGISTRY = Symbol.for('react-native-web.AssetRegistry');
if (!globalObject[ASSET_REGISTRY]) {
  globalObject[ASSET_REGISTRY] = [];
}
var assets = globalObject[ASSET_REGISTRY];
export function registerAsset(asset) {
  // `push` returns new array length, so the first asset will
  // get id 1 (not 0) to make the value truthy
  return assets.push(asset);
}
export function getAssetByID(assetId) {
  return assets[assetId - 1];
}